import validationMessages from '@/utils/validation'

const validationMixin = {
  methods: {
    getValidationErrors (model) {
      const alertErrors = []
      const lang = this.$i18n.locale

      if (this.$v[model] === undefined) {
        console.error('CR: Model is undefined. Check if you define it right as getValidationErrors(???) parameter.')
        return false
      }
      Object.keys(this.$v[model].$params).map((fieldName) => {
        // Go through old params
        Object.keys(this.$v[model][fieldName].$params).map((rule) => {
          if (!this.$v[model][fieldName][rule]) {
            // WIP
            const ruleParams = this.$v[model][fieldName].$params[rule]
            // Maybe use something like es6 destructuring assignment: const { type, ...ruleParams} = ruleParams
            if (ruleParams) delete ruleParams.type
            let message = ''
            // If custom message exist
            if (validationMessages[lang].custom[model] && validationMessages[lang].custom[model][fieldName]) {
              if (validationMessages[lang].custom[model][fieldName][rule]) {
                message = validationMessages[lang].custom[model][fieldName][rule]
              }
              // Else get a global message
            } else if (validationMessages[lang].global[rule]) {
              const field = validationMessages[lang].attributes[model + '.' + fieldName] || fieldName
              let min = ''
              let max = ''
              if (ruleParams) {
                min = ruleParams.min
                max = ruleParams.max
              }
              message = validationMessages[lang].global[rule]
                .replace('{field}', field)
                .replace('{min}', min)
                .replace('{max}', max)
            } else {
              console.error('CR: Validation message for "' + rule + '" rule does not exist.')
            }
            alertErrors.push({
              type: rule,
              msg: message,
              field: fieldName
            })
          }
        })
      })
      return alertErrors
    }
  }
}

export { validationMixin }
